export const LOCALES = ["en", "ar"] as const
export const FALLBACK_LOCALE = "ar"

export type Locale = (typeof LOCALES)[number]
export const RTL_LOCALES: Locale[] = ["ar"]
